import type {FetchFunction} from '../fetch'

type CreateAccountRedirectMiddlewareParams = {
  url: string
}

// пока что миддлвара будет жить тут, наверно до тех пока "auth" не начнет использовать сервис регистрации
function createAccountRedirectMiddleware(
  params: CreateAccountRedirectMiddlewareParams,
) {
  const {url} = params

  function withAccountRedirectMiddleware(
    fetchFn: FetchFunction,
  ): FetchFunction {
    return config => {
      return fetchFn(config).catch(error => {
        if (error.status === 410) {
          window.location.href = url
          return error
        }
        throw error
      })
    }
  }

  return withAccountRedirectMiddleware
}

export {createAccountRedirectMiddleware}
